import {
  BarChart3,
  Compass,
  GitMerge,
  GraduationCap,
  Lightbulb,
  Scale,
  Search,
  ShieldAlert,
  Users,
  Wrench,
} from "lucide-react";
import type { SpecialistAgent } from "@/types";

interface AgentAvatarProps {
  agent: SpecialistAgent;
  size?: "sm" | "md" | "lg";
}

const iconMap = {
  "chart-bar": BarChart3,
  lightbulb: Lightbulb,
  "shield-alert": ShieldAlert,
  tool: Wrench,
  "graduation-cap": GraduationCap,
  search: Search,
  compass: Compass,
  users: Users,
  merge: GitMerge,
  scale: Scale,
};

const sizeClasses = {
  sm: "w-6 h-6",
  md: "w-8 h-8",
  lg: "w-12 h-12",
};

const iconSizeClasses = {
  sm: "w-3 h-3",
  md: "w-5 h-5",
  lg: "w-6 h-6",
};

export function AgentAvatar({ agent, size = "md" }: Readonly<AgentAvatarProps>) {
  const Icon = iconMap[agent.icon as keyof typeof iconMap] || BarChart3;

  return (
    <div
      className={`${sizeClasses[size]} rounded-lg flex items-center justify-center shrink-0`}
      style={{ backgroundColor: agent.color }}
      title={`${agent.name} - ${agent.role}`}
    >
      <Icon className={`${iconSizeClasses[size]} text-white`} />
    </div>
  );
}
